import PropTypes from 'prop-types';
import { forwardRef, useEffect, useState } from 'react';
import { Link as RouterLink } from 'react-router-dom';
// @mui

import { Box, Link } from '@mui/material';

import { getEmpresaAtual } from '../../pages/api';

// ----------------------------------------------------------------------

const Logo = forwardRef(({ disabledLink = false, sx  }, ref) => {

  const [logoSrc, setLogoSrc] = useState('/assets/logo.png');

  useEffect(() => {
    let ativo = true;
    getEmpresaAtual()
      .then((empresa) => {
        if (ativo && empresa?.logoPrincipal) {
          setLogoSrc(empresa.logoPrincipal);
        }
      })
      .catch(() => {
        // Mantém o fallback estático (/assets/logo.png) em caso de erro
      });
    return () => {
      ativo = false;
    };
  }, []);

  // OR using local (public folder)
  // -------------------------------------------------------
   const logo = (
    <Box
       component="img"
       src={logoSrc}
       sx={{ width: 'auto', height: 56, cursor: 'pointer', ...sx }}
       ref={ref}
     />
    
   )
    
   

  if (disabledLink) {
    return <>{logo}</>;
  }

  return (
    <Link to="/modulos" component={RouterLink} sx={{ display: 'contents' }}>
      {logo}
    </Link>
  );
});

Logo.propTypes = {
  sx: PropTypes.object,
  disabledLink: PropTypes.bool,
};

export default Logo;